export interface NotificationBulkSendInterface {
  templateId?: number;
  recipientIds?: number[];
}

export class NotificationBulkSend implements NotificationBulkSendInterface {
  public templateId?: number;
  public recipientIds?: number[];

  constructor({
        templateId = undefined,
        recipientIds = undefined,
    }: NotificationBulkSendInterface) {
    this.templateId = templateId;
    this.recipientIds = recipientIds;
  }
}
